import React from 'react';

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { 
  MAX_NUMBER_OF_ADDITIONAL_QUESTIONS,
  PRODUCTS, 
  MAX_AREA_ADDITIONAL_BUILDINGS 
} from '../lib/constants/appConstants';
import {
  addAdditionalInputs,
  deleteAdditionalInput,
  prefillAdditionalInputs,
  resetAdditionalInputSelections,
  updateAdditionalInputs,
  updateAdditionalInputsSelection,
  updateModifiedInputs
} from '../store/slices/offerSlice';
import './AdditionalInputsContainer.scss';
import { AdditionalInputsSection } from '../components/AdditionalInputs/AdditionalInputsSection';
import InformationHeader from '../components/Common/InformationHeader/InformationHeader';
import {
  IPricingQuestion,
  IPricingStepConfig
} from '../interfaces/EnquiryInterface';
import { AdditionalInputs } from '../interfaces/Types';
import { AppConstants } from '../utils/AppConstants';
import { InsuranceHelper } from '../utils/InsuranceHelper';
interface AdditionalInputsContainerProps {
  isAdditionalInputsAreaInvalid: boolean;
}

export const AdditionalInputsContainer: React.FC<AdditionalInputsContainerProps> = (
  {isAdditionalInputsAreaInvalid}: AdditionalInputsContainerProps
) => {
  const additionalHeaders = [
    {
      code: 'Q001',
      header: AppConstants.getAppText(
        'webshop.villa.extraBuildingSectionHeader'
      ),
      questionOverview: '',
      question: '',
      controlType: 'Information',
      isVisible: true,
      APIKey: '',
      sequence: 2,
      selectedValue: ''
    }
  ];

  const additionalInputsDetails = {
    linkText: "Läs mer om vad som räknas som övrig byggnad",
    description: [{
      title: "Om övriga byggnader",
      details: "Fristående byggnader som inte sitter ihop med huvudbyggnaden, ska du alltid lägga till som övrig byggnad. Om du har en byggnad som sitter ihop med huvudbyggnaden och du kan gå direkt mellan byggnaderna genom exempelvis en dörr, ska du ta upp den som biyta. Finns det inte någon dörr mellan byggnaderna, ska du lägga till byggnaden som övrig byggnad. Carport räknas alltid som övrig byggnad oavsett om det finns dörrförbindelse till huvudbyggnaden eller inte."
    }]
  }

  const stepQuestions = useAppSelector((state) =>
    state.insurance.pricingQuestions.find(
      (item: IPricingStepConfig) => item.stepCode === '001'
    )
  );

  const addedInputs = useAppSelector(
    (state) => state.insurance.additionalInputs
  );
  const dispatch = useAppDispatch();
  const additionalModalInputs: IPricingQuestion[] =
    stepQuestions?.additionalQuestions &&
    stepQuestions?.additionalQuestions.length > 0
      ? stepQuestions?.additionalQuestions
      : [];
  const policyDetails = InsuranceHelper.retrievePolicyInfoFromURL();
  const addAdditionalQuestions = () => {
    if (additionalModalInputs.length > 0) {
      const additionalQuestions = InsuranceHelper.prepareAdditionalQuestions(
        additionalModalInputs
      );
      if (
        additionalQuestions.type.label !== '' &&
        additionalQuestions.area.label !== '' &&
        additionalQuestions.energyType.label !== ''
      ) {
        dispatch(addAdditionalInputs(additionalQuestions));
        //This is to handle the edit when coming back to offer.
        if (policyDetails.customerNumber && policyDetails.policyNumber) {
          dispatch(
            updateModifiedInputs({
              isAdditionalInputsUpdated: true
            })
          );
        }
      }
      dispatch(resetAdditionalInputSelections('001'));
    }
  };
  const resetAdditionalQuestions = () => {
    dispatch(resetAdditionalInputSelections('001'));
  };
  const updateAdditionalQuestions = (editIndex: number) => {
    if (additionalModalInputs.length > 0) {
      const additionalQuestions = InsuranceHelper.prepareAdditionalQuestions(
        additionalModalInputs
      );
      if (
        additionalQuestions.type.label !== '' &&
        additionalQuestions.area.label !== '' &&
        additionalQuestions.energyType.label !== ''
      ) {
        dispatch(
          updateAdditionalInputs({
            updatedItem: additionalQuestions,
            editIndex
          })
        );
        if (policyDetails.customerNumber && policyDetails.policyNumber) {
          dispatch(
            updateModifiedInputs({
              isAdditionalInputsUpdated: true
            })
          );
        }
      }
    }
  };
  const deleteAdditionalQuestion = (deleteIndex: number) => {
    dispatch(deleteAdditionalInput(deleteIndex));
    if (policyDetails.customerNumber && policyDetails.policyNumber) {
      dispatch(
        updateModifiedInputs({
          isAdditionalInputsUpdated: true
        })
      );
    }
  };
  const prefillInputs = (item: AdditionalInputs) => {
    dispatch(
      prefillAdditionalInputs({
        stepCode: '001',
        item
      })
    );
  };
  const handleChange = (type: string, value: string, isValid?: boolean) => {
    updateSelection(type, value, isValid);
  };
  const updateSelection = (type: string, value: string, isValid?: boolean) => {
    dispatch(
      updateAdditionalInputsSelection({
        questionType: type,
        selectedOption: value,
        stepCode: '001',
        isValid: !!isValid
      })
    );
  };
  const productName = useAppSelector((state) => state.insurance.offer.productName);

  const isAboveNumberOfAdditionalQuestionsThreshold: boolean =
    addedInputs?.length === MAX_NUMBER_OF_ADDITIONAL_QUESTIONS[productName];
  
  
  return (
    <>
      {additionalModalInputs.length > 0 && (
        <div className="additional-input-container">
          {additionalHeaders.map((item: IPricingQuestion, index: number) => {
            return (
              item.isVisible && (
                <div key={index}>
                  <InformationHeader
                    title={item.header}
                    informationText={item.question}
                    alignCenter={false}
                    mainHeader={false}
                  />
                </div>
              )
            );
          })}
          <div className="add-inputs-section pt-2">
            <AdditionalInputsSection
              additionalModalInputs={additionalModalInputs}
              addAdditionalQuestions={addAdditionalQuestions}
              handleModalInputChange={handleChange}
              onEditButtonClick={prefillInputs}
              addedInputs={addedInputs}
              resetAdditionalQuestions={resetAdditionalQuestions}
              updateAdditionalQuestions={updateAdditionalQuestions}
              deleteAdditionalQuestion={deleteAdditionalQuestion}
              isMaxQuestionsReached={isAboveNumberOfAdditionalQuestionsThreshold}
              isAboveAreaThreshold={isAdditionalInputsAreaInvalid}
              additionalInputsDetails={additionalInputsDetails}
            />
          </div>
        </div>
      )}
    </>
  );
};
